import axios from 'axios';
import { GET_HEADER, GET_FOOTER, GET_FOOTER_TAIL } from '../../Config/Api.route.config';

const queryString = window.location.search;
let country = undefined, language = undefined;
const urlParams = new URLSearchParams(queryString);
country = urlParams.get('c');
language = urlParams.get('l');

if (language === 'undefined' || !language) {
    language = 'en';
}

if (country === 'undefined' || !country) {
    country = 'us';
}

function getHeader() {
    return axios({
        url: GET_HEADER,
        method: "GET",
    });
};

function getFooter(langFlag) {
    let footerUrl = "";
    if (langFlag) {
        if (country === "us" && language === "en") {
            footerUrl = `${GET_FOOTER}us/en/dhs/19${GET_FOOTER_TAIL}`;
        } else {
            footerUrl = `${GET_FOOTER}${country}/${language}/dhs/${country}dhs1${GET_FOOTER_TAIL}`;
        }
    }
    else {
        footerUrl = `${GET_FOOTER}us/en/dhs/19${GET_FOOTER_TAIL}`;
    }

    return axios({
        url: footerUrl,
        method: "GET",
    });
};


const PmcSignUpService = {
    getHeader,
    getFooter
}

export default PmcSignUpService;